const minDate = (date1: Date, date2: Date) => {
  return new Date(Math.min(date1.getTime(), date2.getTime()))
    .toISOString()
    .split('T')[0]
}

export { minDate }
